import Plusone from '@/components/api/plusone';

const state = {
  bcNo: '001',
  stampCount: 0,
  giftProductMap: [],
  stampStatus: null,
  selectedGiftProduct: null,
}

const getters = {
  bcNo: state => state.bcNo,
  stampCount: state => state.stampCount,
  giftProductMap: state => state.giftProductMap,
  stampStatus: state => state.stampStatus,
  selectedGiftProduct: state => state.selectedGiftProduct,
}

const actions = {
  updateStampCount({ state, commit }) {
    const maxStampCount = 13;
    Plusone.getStamp(state.bcNo).then((val) => {
      console.log('getStamp', val);
      console.log('val.giftProductMap', val.giftProductMap);
      if(val) {
        if(val.giftProductMap[0].giftProductId !== 0 && val.status === "ACHIVED_SELECTED") {
          // プレゼントを選択している場合
          commit('setSelectedGiftProduct', val.giftProductMap[0]);
        }
        commit('setStampStatus', val.status);
        let stampCount = val.stampCount;
        if(stampCount === 12) {
          stampCount = 13;
        }
        for (let i = 0; i <= stampCount; i++) {
          if (i > maxStampCount) {
            break;
          }
          setTimeout(() => {
            commit('setStampCount', i);
          }, i * 500); // 0.5秒ごとに更新
        }
      }
    }).catch((error) => {
      console.error('Failed to get stamp:', error);
    });
  },
  fetchAllProduct({ commit }, bcNo) {
    Plusone.getAllPresents(bcNo).then((val) => {
      console.log('getAllProduct', val);
      if(val) {
        commit('setGiftProductMap', val.giftProductMap);
      }
    });
  }
}

const mutations = {
  setMemberId(state, memberId) {
    state.memberId = memberId;
  },
  setStampCount(state, count) {
    state.stampCount = count;
  },
  setGiftProductMap(state, map) {
    state.giftProductMap = map;
  },
  setStampStatus(state, status) {
    state.stampStatus = status;
  },
  setSelectedGiftProduct(state, product) {
    state.selectedGiftProduct = product;
  },
}


export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/keepgoing.js